module.exports = __webpack_public_path__ + "static/media/sum-insured.0ca428c6.svg";